// src/types/agent.ts
export interface AgentConfiguration {
  id: string;
  branch_id: string;
  agent_name?: string;
  tone: string;
  language: string;
  identity: string;
  helping_strategy: string;
  include_food_safety: boolean;
  mention_featured_items: boolean;
  use_humor: boolean;
  response_length: "short" | "medium" | "long";
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface AgentConfigurationInput {
  agent_name?: string;
  tone: string;
  language: string;
  identity: string;
  helping_strategy: string;
  include_food_safety: boolean;
  mention_featured_items: boolean;
  use_humor: boolean;
  response_length: "short" | "medium" | "long";
  is_active: boolean;
  ordering: boolean;
}

// Predefined options for autocomplete
export const TONE_OPTIONS = [
  {
    value: "friendly",
    labelKey: "agent.tones.friendly.label",
    descriptionKey: "agent.tones.friendly.description",
  },
  {
    value: "professional and formal",
    labelKey: "agent.tones.professional.label",
    descriptionKey: "agent.tones.professional.description",
  },
  {
    value: "casual",
    labelKey: "agent.tones.casual.label",
    descriptionKey: "agent.tones.casual.description",
  },
  {
    value: "humorous",
    labelKey: "agent.tones.humorous.label",
    descriptionKey: "agent.tones.humorous.description",
  },
  {
    value: "warm",
    labelKey: "agent.tones.warm.label",
    descriptionKey: "agent.tones.warm.description",
  },
  {
    value: "energetic",
    labelKey: "agent.tones.energetic.label",
    descriptionKey: "agent.tones.energetic.description",
  },
];

export const LANGUAGE_OPTIONS = [
  {
    value: "multilingual",
    labelKey: "agent.languages.multilingual.label",
    descriptionKey: "agent.languages.multilingual.description",
  },
  {
    value: "lebanese_arabish",
    labelKey: "agent.languages.lebaneseArabish.label",
    descriptionKey: "agent.languages.lebaneseArabish.description",
  },
  {
    value: "english",
    labelKey: "agent.languages.english.label",
    descriptionKey: "agent.languages.english.description",
  },
  {
    value: "french",
    labelKey: "agent.languages.french.label",
    descriptionKey: "agent.languages.french.description",
  },
  {
    value: "arabic",
    labelKey: "agent.languages.arabic.label",
    descriptionKey: "agent.languages.arabic.description",
  },
  {
    value: "mixed",
    labelKey: "agent.languages.mixed.label",
    descriptionKey: "agent.languages.mixed.description",
  },
];

export const IDENTITY_OPTIONS = [
  {
    value: "dining_assistant",
    labelKey: "agent.identities.diningAssistant.label",
    descriptionKey: "agent.identities.diningAssistant.description",
  },
  {
    value: "chef_consultant",
    labelKey: "agent.identities.chefConsultant.label",
    descriptionKey: "agent.identities.chefConsultant.description",
  },
  {
    value: "food_connoisseur",
    labelKey: "agent.identities.foodConnoisseur.label",
    descriptionKey: "agent.identities.foodConnoisseur.description",
  },
  {
    value: "friendly_waiter",
    labelKey: "agent.identities.friendlyWaiter.label",
    descriptionKey: "agent.identities.friendlyWaiter.description",
  },
  {
    value: "nutrition_guide",
    labelKey: "agent.identities.nutritionGuide.label",
    descriptionKey: "agent.identities.nutritionGuide.description",
  },
];

export const HELPING_STRATEGY_OPTIONS = [
  {
    value: "conversational",
    labelKey: "agent.strategies.conversational.label",
    descriptionKey: "agent.strategies.conversational.description",
  },
  {
    value: "direct",
    labelKey: "agent.strategies.direct.label",
    descriptionKey: "agent.strategies.direct.description",
  },
  {
    value: "consultative",
    labelKey: "agent.strategies.consultative.label",
    descriptionKey: "agent.strategies.consultative.description",
  },
  {
    value: "educational",
    labelKey: "agent.strategies.educational.label",
    descriptionKey: "agent.strategies.educational.description",
  },
  {
    value: "quick_service",
    labelKey: "agent.strategies.quickService.label",
    descriptionKey: "agent.strategies.quickService.description",
  },
];

export const RESPONSE_LENGTH_OPTIONS = [
  {
    value: "short",
    labelKey: "agent.responseLengths.short.label",
    descriptionKey: "agent.responseLengths.short.description",
  },
  {
    value: "medium",
    labelKey: "agent.responseLengths.medium.label",
    descriptionKey: "agent.responseLengths.medium.description",
  },
  {
    value: "long",
    labelKey: "agent.responseLengths.long.label",
    descriptionKey: "agent.responseLengths.long.description",
  },
] as const;
